// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2uTnH","alert":"SettungsInbox_alert__GEBpp"};